// UI_PREVIEW_MODE=true  → demo data in browser localStorage (no backend)
// UI_PREVIEW_MODE=false → uses backend + Firebase Firestore (production)
export const UI_PREVIEW_MODE = process.env.REACT_APP_UI_PREVIEW_MODE === "true";

// Set REACT_APP_FIREBASE_API_KEY in .env to enable Google Sign-In
export const USE_FIREBASE_AUTH = Boolean(process.env.REACT_APP_FIREBASE_API_KEY);

// Dev bypass when Firebase is not configured (preview only)
export const SKIP_ADMIN_LOGIN =
  process.env.REACT_APP_SKIP_ADMIN_LOGIN === "true" || !USE_FIREBASE_AUTH;

// Production build uses same-origin /api (Firebase Hosting → Cloud Functions).
// Local dev uses backend on port 5000.
export const API_URL =
  process.env.REACT_APP_API_URL !== undefined && process.env.REACT_APP_API_URL !== ""
    ? process.env.REACT_APP_API_URL
    : process.env.NODE_ENV === "production"
      ? ""
      : "http://localhost:5000";

// Used for admin whitelist check in preview mode (must match backend ADMIN_EMAILS)
export const ADMIN_EMAILS = (process.env.REACT_APP_ADMIN_EMAILS || "")
  .split(",")
  .map((email) => email.trim().toLowerCase())
  .filter(Boolean);

export function isAdminEmail(email) {
  return ADMIN_EMAILS.includes((email || "").trim().toLowerCase());
}
